/*
 *
 * App constants
 *
 */

const constantKey = 'app/containers/App';

const appConstants = {
  DEFAULT_ACTION: `${constantKey}/DEFAULT_ACTION`,
  DEFAULT_ACTION_SUCCESS: `${constantKey}/DEFAULT_ACTION_SUCCESS`,
  DEFAULT_ACTION_ERROR: `${constantKey}/DEFAULT_ACTION_ERROR`,

  TOGGLE_THEME: `${constantKey}/TOGGLE_THEME`,
  SET_APP_LOADED: `${constantKey}/SET_APP_LOADED`,
  SET_TOKEN: `${constantKey}/SET_TOKEN`,
};

export default appConstants;
